<!-- INC-328: inside the interrupt frame the title and the close control belong to the
     frame, so this header would double up with them. Standalone (the single-interrupt
     path) it renders exactly as before. -->
@if (!hostOwnsChrome) {
  <div class="modal-header pvm-header">
    <h5 class="modal-title pvm-title">
      <p-icon
        [name]="'info-circle'"
        [iconClass]="'tw-w-5 tw-h-5'"
        class="pvm-title-icon"
        aria-hidden="true"
      ></p-icon>
      Your vote is needed
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
}

<div class="modal-body pvm-body">
  <div class="d-flex align-items-center pvm-company tw-gap-4">
    <div class="ca-logo">{{ pendingVote?.companyName | slice: 0 : 2 | uppercase }}</div>
    <div class="flex-fill">
      <div class="pvm-company-name">{{ pendingVote?.companyName }}</div>
      <span class="badge ca-badge-type mt-1">
        <p-icon [name]="'dashboard'" [iconClass]="'tw-w-3 tw-h-3'"></p-icon> {{ pendingVote?.type }}
      </span>
    </div>
  </div>

  <p class="pvm-description">
    {{ pendingVote?.companyName }} wants to buy back the shares pitchIN holds for you. Vote to
    approve or reject the offer before voting closes.
  </p>

  @if (daysLeft !== null) {
    <p class="pvm-deadline">
      <p-icon
        [name]="'calendar'"
        [iconClass]="'tw-w-4 tw-h-4'"
        class="me-1"
        aria-hidden="true"
      ></p-icon>
      @if (pendingVote?.votingClosesAt) {
        <span>Voting closes {{ pendingVote.votingClosesAt | date: 'd MMM yyyy' }} · </span>
      }
      <strong>{{ daysLeft }}</strong
      >&nbsp;day
      @if (daysLeft !== 1) {
        <span>s</span>
      }
      left
    </p>
  }
</div>

<div class="modal-footer pvm-footer">
  <button type="button" class="btn btn-grey-border" (click)="dismiss()">Later</button>
  <button type="button" class="btn btn-primary pvm-cta" (click)="reviewAndVote()">
    Review &amp; vote
  </button>
</div>

<p class="pvm-reminder">We'll remind you each time you log in until you vote.</p>
